import VerifyEmail from "../../../../jsx/components/Dashboard/VerifyEmail/VerifyEmail";

const VerifyEmailWrapper = () => {
  return <VerifyEmail />;
};

export default constore(VerifyEmailWrapper);
